import 'proxy-polyfill'
import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import './index.less'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { languageObj } from './utils/common'
import store from './redux'
import { setDeviceSize, setLanguageObj } from './redux/actions/commonActions'
import { Provider } from 'react-redux'

const initDeviceSize = () => {
  const deviceWidth = document.documentElement.clientWidth
  let size = Math.max(deviceWidth, 1000) / 1280
  store.dispatch(setDeviceSize(size))
  document.documentElement.style.setProperty('--device-size', size)
}
initDeviceSize()
const state = store.getState()
const language = state.commonStore.language
if (language === 'zh_CN') {
  store.dispatch(setLanguageObj(languageObj['zh_CN']))
}
if (language === 'en_US') {
  store.dispatch(setLanguageObj(languageObj['en_US']))
}
ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
